<script>
import Consulta from './consulta.vue';
import Form from './form.vue';


export default {
    name: 'Consulta',
    props: {
        consultas: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            parent: {
                id: null,
                parent: null,
                description: null,
                children: [],
            },
            consulta: {
                id: null,
                descricao: null,
                consulta: null,
                parent: null,
            },
        }
    },
    components: { Consulta, Form },
    methods: {
        accordionName(consulta) {
            return 'accordion' + consulta.id;
        },
        add(parent) {
            this.parent = parent
            this.consulta = {
                id: null,
                descricao: null,
                consulta: null,
                parent: null,
            }
            this.$refs.form.modal = true
            this.$refs.form.id = null
        },
        update(consulta) {
            this.$axios
                .get(process.env.VUE_APP_API_URL + '/api/master/query_repositories/' + consulta.id, { headers: this.$headers })
                .then(response => {
                    this.consulta = {
                        id: consulta.id,
                        descricao: consulta.description,
                        consulta: response.data.query,
                        parent: consulta.parent,
                    }
                    this.$refs.form.modal = true
                    this.$refs.form.id = consulta.id
                })
                .catch(error => this.$axiosCatch(error))
                .finally(() => { })
        },
    },
}

</script>

<template>
    <div>
        <b-card no-body class="mb-1" v-for="consulta in consultas" :key="consulta.id">
            <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                    <a @click="add(consulta)" style="cursor: pointer;"><i class="bx bx-plus"></i></a>
                    <a @click="update(consulta)" style="cursor: pointer;"><i class="bx bx-pencil"></i></a>

                    <a v-b-toggle="'accordion' + consulta.id" class="text-dark" href="javascript: void(0);">
                        {{ consulta.id + ' - ' + consulta.description }}
                    </a>
                </h6>
            </b-card-header>
            <b-collapse :id="'accordion' + consulta.id" :accordion="accordionName(consulta)" role="tabpanel">
                <b-card-body>
                    <Consulta v-if="consulta.children && consulta.children.length > 0" :consultas="consulta.children" />
                    <b-alert v-else show variant="secondary">Nenhuma consulta</b-alert>

                </b-card-body>
            </b-collapse>
        </b-card>
        <Form ref="form" :parent="parent" :consulta="consulta" />
    </div>
</template>